module.exports = __webpack_public_path__ + "static/media/img3.fc6d1a42.png";